import '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import { getProductCategories } from '../utils/get-product-categories.js';
import '../utils/http-client.js';

const useBloomreachSdpContent = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const page = useBrPageContext();
    const models = (ref = page === null || page === void 0 ? void 0 : page.getComponent('main')) === null || ref === void 0 ? void 0 : ref.getModels();
    const storeDocument = models === null || models === void 0 ? void 0 : models.storeDetailDocument;
    if (!page || !storeDocument) {
        return {};
    }
    const content = (ref1 = page === null || page === void 0 ? void 0 : page.getContent(storeDocument)) === null || ref1 === void 0 ? void 0 : ref1.getData();
    if (!content) {
        console.warn(`Cannot find main content for StoreDetailPage pageModel. Got: ${content} for $ref: ${storeDocument}`);
        return {};
    }
    const storeDetailCampaignRef = content === null || content === void 0 ? void 0 : (ref2 = content.storeDetailCampaign) === null || ref2 === void 0 ? void 0 : ref2.image;
    const campaignBannerContent = storeDetailCampaignRef ? page.getContent(storeDetailCampaignRef) : undefined;
    const campaignBanner = campaignBannerContent && {
        description: campaignBannerContent.getDescription(),
        url: (ref3 = campaignBannerContent.getOriginal()) === null || ref3 === void 0 ? void 0 : ref3.getUrl()
    };
    const productCategories = getProductCategories(content === null || content === void 0 ? void 0 : content.productCategoriesCompound, page);
    const { storeFallbackImage , offerFallbackImage , productCategoryFallbackImage , paymentIcons , socialMediaIcons , storeDetailCampaign ,  } = content;
    var ref8, ref9, ref10, ref11;
    return {
        storeFallbackImage: {
            url: (ref8 = storeFallbackImage === null || storeFallbackImage === void 0 ? void 0 : storeFallbackImage.url) !== null && ref8 !== void 0 ? ref8 : undefined,
            width: (ref9 = storeFallbackImage === null || storeFallbackImage === void 0 ? void 0 : (ref4 = storeFallbackImage.original) === null || ref4 === void 0 ? void 0 : ref4.width) !== null && ref9 !== void 0 ? ref9 : undefined,
            height: (ref10 = storeFallbackImage === null || storeFallbackImage === void 0 ? void 0 : (ref5 = storeFallbackImage.original) === null || ref5 === void 0 ? void 0 : ref5.height) !== null && ref10 !== void 0 ? ref10 : undefined,
            description: (ref11 = storeFallbackImage === null || storeFallbackImage === void 0 ? void 0 : storeFallbackImage.description) !== null && ref11 !== void 0 ? ref11 : undefined
        },
        offerFallbackImage: offerFallbackImage === null || offerFallbackImage === void 0 ? void 0 : offerFallbackImage.url,
        productCategoryFallbackImage: productCategoryFallbackImage === null || productCategoryFallbackImage === void 0 ? void 0 : productCategoryFallbackImage.url,
        productCategories,
        paymentIcons,
        socialMediaIcons,
        campaignBanner: {
            description: campaignBanner === null || campaignBanner === void 0 ? void 0 : campaignBanner.description,
            url: campaignBanner === null || campaignBanner === void 0 ? void 0 : campaignBanner.url,
            startDate: storeDetailCampaign === null || storeDetailCampaign === void 0 ? void 0 : (ref6 = storeDetailCampaign.startEndDate) === null || ref6 === void 0 ? void 0 : ref6.startDate,
            endDate: storeDetailCampaign === null || storeDetailCampaign === void 0 ? void 0 : (ref7 = storeDetailCampaign.startEndDate) === null || ref7 === void 0 ? void 0 : ref7.endDate,
            storesList: storeDetailCampaign === null || storeDetailCampaign === void 0 ? void 0 : storeDetailCampaign.storesList
        }
    };
};

export { useBloomreachSdpContent };
//# sourceMappingURL=use-bloomreach-sdp-content.js.map
